module.exports = __webpack_public_path__ + "img/llm.2751ce48.png";